import { Select, Tag, Spin, Typography } from "antd";
import { useAtom } from "jotai";
import { useLocation } from "react-router-dom";
import { userDesignationsQueryAtom } from "../../services/queries";
import { useEffect, useState, useMemo } from "react";
import { CheckOutlined } from "@ant-design/icons";
import Utils from "../../utils/functions";

const { splitAndFirstLetterOnlyToUpperCase } = Utils;

const { Text } = Typography;

const UserDesignationSelector = ({ value, onChange }) => {
  const { state: locationState } = useLocation();

  const [selectedDesignation, setSelectedDesignation] = useState(null);

  const [
    {
      data: userDesignations,
      isError: isUserDesignationsDataError,
      isLoading: isUserDesignationsDataLoading,
    },
  ] = useAtom(userDesignationsQueryAtom, { delay: 0 });

  // Memoize designation options to prevent unnecessary re-renders
  const designationOptions = useMemo(() => {
    if (!userDesignations) return [];
    return userDesignations
      .map((opt) => ({
        label: splitAndFirstLetterOnlyToUpperCase(opt.name, "_"),
        value: opt.name,
        color: "blue",
      }))
      .sort();
  }, [userDesignations]);

  useEffect(() => {
    if (value && value !== selectedDesignation) {
      setSelectedDesignation(value);
    }
  }, [value]); // Only run when value changes

  const handleChange = (selectedValue) => {
    if (selectedValue !== selectedDesignation) {
      setSelectedDesignation(selectedValue);
      onChange(selectedValue);
    }
  };

  if (isUserDesignationsDataError) {
    return <Text type="danger">Failed to load designations</Text>;
  }

  if (isUserDesignationsDataLoading) {
    return (
      <Spin
        style={{ width: "100%", display: "flex", justifyContent: "center" }}
        size="large"
      />
    );
  }

  return (
    <Select
      value={selectedDesignation}
      onChange={handleChange}
      style={{ width: "100%", minWidth: "200px" }}
      placeholder="Select designation"
      optionFilterProp="children"
      showSearch
      filterOption={(input, option) => {
        return option?.value
          ?.toLowerCase()
          .includes(input.valueOf("string").toLowerCase());
      }}
      filterSort={(optionA, optionB) => {
        return (optionA?.value || "")
          .toLowerCase()
          .localeCompare((optionB?.value || "").toLowerCase());
      }}
    >
      {designationOptions.map((designation) => (
        <Select.Option
          key={designation.value}
          value={designation.value}
          label={
            <Tag color={designation.color} style={{ marginRight: 8 }}>
              {designation.label}
            </Tag>
          }
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            {selectedDesignation === designation.value && (
              <CheckOutlined style={{ marginRight: 8, color: "#52c41a" }} />
            )}
            <Tag color={designation.color}>{designation.label}</Tag>
          </div>
        </Select.Option>
      ))}
    </Select>
  );
};

export default UserDesignationSelector;
